
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { useExplorePrompts } from "@/hooks/useExplorePrompts";
import FilterSection from "@/components/explore/FilterSection";
import ExploreContent from "@/components/explore/ExploreContent";
import { useScrollTracking } from "@/hooks/useScrollTracking";
import { analytics } from "@/services/analytics/analyticsService";

const ExplorePage = () => {
  const [searchParams] = useSearchParams();
  const categorySlugParam = searchParams.get("category");
  const searchParam = searchParams.get("q");
  
  const {
    prompts,
    isLoading,
    selectedCategory,
    currentPage,
    setCurrentPage,
    totalPrompts,
    totalPages,
    searchQuery,
    handleSearch,
    handleCategoryFilter,
    clearFilters,
    ITEMS_PER_PAGE,
    categories,
    isInitLoading,
    isCategoryFiltering,
    error,
    categoriesLoaded,
    // New filter properties
    selectedSort,
    selectedTimeFilter,
    handleSortChange,
    handleTimeFilterChange,
    hasFilters
  } = useExplorePrompts();

  // Track scroll depth on this page
  useScrollTracking();

  // Track category selection for analytics
  useEffect(() => {
    if (selectedCategory) {
      const categoryParam = new URLSearchParams(window.location.search).get('category');
      if (categoryParam) {
        analytics.trackCategorySelect(selectedCategory, categoryParam);
      }
    }
  }, [selectedCategory]);

  // Log page state for debugging
  useEffect(() => {
    console.log('Explore Page State:', { 
      promptCount: prompts.length,
      isLoading,
      totalPrompts,
      currentPage,
      totalPages,
      hasFilters: hasFilters
    });
  }, [prompts, isLoading, totalPrompts, currentPage, totalPages, hasFilters]);

  // Determine which prompts to display
  const hasError = !!error;

  // Only disable the filter controls during categories loading
  // Categories should be clickable even during data loading
  const filterControlsDisabled = !categoriesLoaded;

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      
      <div className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="container mx-auto max-w-6xl">
          <FilterSection
            categories={categories}
            selectedCategory={selectedCategory}
            onCategoryFilter={handleCategoryFilter}
            onSearch={handleSearch}
            hasFilters={hasFilters}
            onClearFilters={clearFilters}
            disabled={filterControlsDisabled}
            selectedSort={selectedSort}
            selectedTimeFilter={selectedTimeFilter}
            onSortChange={handleSortChange}
            onTimeFilterChange={handleTimeFilterChange}
          />
          
          <ExploreContent
            isLoading={isLoading}
            prompts={prompts}
            searchQuery={searchQuery}
            currentPage={currentPage}
            totalPrompts={totalPrompts}
            totalPages={totalPages}
            setCurrentPage={setCurrentPage}
            itemsPerPage={ITEMS_PER_PAGE}
            hasError={hasError}
            isCategoryFiltering={isCategoryFiltering}
          />
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default ExplorePage;
